var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 204,
    viewBox: "0 0 210 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_23838)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 203.871,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.0893 11.644C71.1738 14.4411 60.3972 21.5656 54.2532 33.6287C43.2452 55.2418 47.928 71.0604 44.0784 87.0309C40.2288 103.001 28.4264 108.355 19.9377 120.855C13.3119 130.612 12.2652 154.344 24.1392 166.194C35.8863 177.824 46.7191 188.608 67.8101 185.322C88.6897 182.168 99.2169 167.559 121.153 163.001C143.09 158.443 161.258 162.616 172.932 151.8C185.174 140.458 197.907 109.087 186.97 86.4448C178.172 68.2325 156.781 64.155 146.345 47.0842C135.909 30.0133 130.903 22.412 121.901 18.3301C109.458 12.6872 100.095 9.35823 87.0893 11.644Z",
    stroke: "#90734F",
    strokeOpacity: 0.08,
    strokeWidth: 1.10606
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9503 42.6223C82.2603 44.5011 75.0219 49.2864 70.8951 57.3889C63.5012 71.9059 66.6466 82.5309 64.0609 93.258C61.4752 103.985 53.5478 107.581 47.8461 115.977C43.3957 122.53 42.6927 138.471 50.6682 146.43C58.5585 154.242 65.8346 161.485 80.0009 159.278C94.0253 157.159 101.096 147.347 115.83 144.285C130.565 141.224 142.768 144.027 150.609 136.762C158.831 129.144 167.384 108.073 160.038 92.8643C154.128 80.6315 139.761 77.8928 132.751 66.4267C125.742 54.9606 122.379 49.8549 116.333 47.1132C107.975 43.323 101.686 41.087 92.9503 42.6223Z",
    stroke: "#90734F",
    strokeOpacity: 0.08,
    strokeWidth: 2.21212
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.5303 27.6225C77.3084 29.9463 68.3556 35.865 63.2514 45.8865C54.1064 63.8418 57.9967 76.9833 54.7986 90.251C51.6005 103.519 41.7955 107.966 34.7435 118.351C29.239 126.456 28.3695 146.172 38.2339 156.016C47.993 165.678 56.9924 174.637 74.5139 171.908C91.8599 169.287 100.605 157.151 118.829 153.364C137.054 149.577 152.147 153.044 161.845 144.059C172.015 134.636 182.594 108.574 173.507 89.764C166.198 74.634 148.427 71.2466 139.758 57.0648C131.088 42.8831 126.929 36.5682 119.451 33.1771C109.113 28.4892 101.335 25.7236 90.5303 27.6225Z",
    stroke: "#90734F",
    strokeOpacity: 0.08,
    strokeWidth: 1.65909
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8158 52.1654C86.7311 53.762 80.5798 57.8287 77.0727 64.7144C70.7892 77.0514 73.4622 86.0808 71.2648 95.1969C69.0675 104.313 62.3305 107.369 57.4851 114.504C53.7031 120.073 53.1056 133.62 59.8834 140.384C66.5888 147.022 72.7722 153.178 84.8111 151.302C96.7294 149.502 102.738 141.163 115.26 138.561C127.782 135.96 138.152 138.342 144.816 132.168C151.803 125.693 159.072 107.787 152.828 94.8623C147.807 84.4666 135.596 82.1391 129.64 72.395C123.683 62.6508 120.825 58.3119 115.687 55.9819C108.584 52.7608 103.239 50.8607 95.8158 52.1654Z",
    fill: "#90734F",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    filter: "url(#filter0_f_897_23838)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.9407 -148.142C-46.6202 -143.278 -65.3623 -130.887 -76.0477 -109.908C-95.1925 -72.319 -87.0484 -44.8079 -93.7434 -17.0326C-100.438 10.7428 -120.965 20.0531 -135.728 41.7927C-147.251 58.7613 -149.072 100.036 -128.421 120.644C-107.991 140.871 -89.1509 159.626 -52.4702 153.912C-16.1572 148.426 2.1512 123.019 40.3024 115.092C78.4536 107.164 110.051 114.423 130.354 95.6111C151.644 75.8852 173.79 21.3268 154.767 -18.052C139.466 -49.726 102.264 -56.8174 84.1149 -86.5063C65.9654 -116.195 57.2576 -129.415 41.6033 -136.514C19.9623 -146.328 3.67786 -152.118 -18.9407 -148.142Z",
    fill: "#FF00F5"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105 97.1211L108.081 100.202C108.198 100.319 108.388 100.319 108.505 100.202L109.495 99.212C109.612 99.0948 109.612 98.9048 109.495 98.7877L105.795 95.0877C105.739 95.0314 105.662 94.9998 105.583 94.9998L104.417 94.9998C104.338 94.9998 104.261 95.0314 104.205 95.0877L100.505 98.7877C100.388 98.9048 100.388 99.0948 100.505 99.212L101.495 100.202C101.612 100.319 101.802 100.319 101.919 100.202L105 97.1211Z",
    fill: "#90734F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.7 106C105.866 106 106 105.866 106 105.7V96.3C106 96.1343 105.866 96 105.7 96H104.3C104.134 96 104 96.1343 104 96.3V105.7C104 105.866 104.134 106 104.3 106H105.7Z",
    fill: "#90734F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.912 108.088C111.968 108.032 112 107.955 112 107.876V104.3C112 104.134 111.866 104 111.7 104H110.3C110.134 104 110 104.134 110 104.3V107H100V104.3C100 104.134 99.8657 104 99.7 104H98.3C98.1343 104 98 104.134 98 104.3V107.876C98 107.955 98.0316 108.032 98.0879 108.088L98.9121 108.912C98.9684 108.968 99.0447 109 99.1243 109H110.876C110.955 109 111.032 108.968 111.088 108.912L111.912 108.088Z",
    fill: "#90734F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_897_23838",
    x: -384.229,
    y: -389.41,
    width: 786.229,
    height: 784.362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_897_23838"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_23838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 203.871,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEmpty);
export default __webpack_public_path__ + "static/media/product-empty.a11ccca8be862d1ddfd36dcd64308705.svg";
export { ForwardRef as ReactComponent };